import React from 'react';
import ReactTagsInput from 'react-tagsinput';
import styled from 'styled-components/macro';

type Props = {
  value: string[] | string;
  onChange: (value: string[]) => void;
  className?: string;
  inputClassName?: string;
  tagClassName?: string;
  removeClassName?: string;
};

const maxTags = 10;

const TagsInputRoot = styled(ReactTagsInput)`
  overflow: hidden;
  border: 1px solid #ccc;
  padding: 2px;
  border-radius: 4px;
  background: #fff;
  transition: 0.3s border-color;
  cursor: text;

  & .tag {
    a {
      :hover,
      :focus {
        text-decoration: none;
      }

      ::before {
        content: ' ×';
      }
    }
  }

  & .remove {
    cursor: pointer;
    font-weight: bold;
    color: #fff;
  }

  & .input {
    background: transparent;
    border: 0;
    font-size: 0.9rem;
    font-weight: 400;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 2px 5px;
    width: 220px;
    outline: 0;
  }

  &.focus {
    border-color: #888;
  }
`;

export const ReactTagsWrapper = (props: Props) => {
  const {
    className = '',
    inputClassName = '',
    tagClassName = '',
    removeClassName = '',
    value,
    onChange,
    ...rest
  } = props;
  const tagsAllowed = maxTags - (Array.isArray(value) ? value.length : 0);
  const placeholder = tagsAllowed > 0 ? `Add up to ${tagsAllowed} separate tag(s)` : '';

  return (
    <TagsInputRoot
      {...rest}
      value={[].concat(value as never)}
      onChange={onChange}
      onlyUnique
      className={`wrapper ${className}`}
      inputProps={{
        className: `input ${inputClassName}`,
        placeholder,
      }}
      tagProps={{
        className: `tag ${tagClassName}`,
        classNameRemove: `remove ${removeClassName}`,
      }}
      focusedClassName="focus"
      addOnBlur
      addKeys={[
        9, // Tab
        13, // Enter
        188, // Comma
      ]}
      maxTags={maxTags}
    />
  );
};
